import { render, staticRenderFns } from "./PeriodReward.vue?vue&type=template&id=19d7b6a0&scoped=true&"
import script from "./PeriodReward.vue?vue&type=script&lang=js&"
export * from "./PeriodReward.vue?vue&type=script&lang=js&"
import style0 from "./PeriodReward.vue?vue&type=style&index=0&id=19d7b6a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d7b6a0",
  null
  
)

export default component.exports